var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 498.087,
    y2: 13.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c54a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b1d2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.83 14.826a25.853 25.853 0 0 1 23.044 4.76 25.9 25.9 0 0 1 10.365 21.168v63.557h-380.629zm71.145 476.4a6.861 6.861 0 0 1 -6.843 6.863h-478.289a6.861 6.861 0 0 1 -6.843-6.865v-362.989a6.845 6.845 0 0 1 3.17-5.771l4.23-1.092h477.732a6.86 6.86 0 0 1 6.843 6.863v104.2h-93.585a77.293 77.293 0 0 0 0 154.586h93.585v104.2zm20.025-121.27v-120.456h-113.61a60.227 60.227 0 0 0 0 120.453zm-139.22-60.226a32.906 32.906 0 1 0 32.906-32.906 32.932 32.932 0 0 0 -32.906 32.906zm32.906-15.839a15.839 15.839 0 1 0 15.848 15.839 15.851 15.851 0 0 0 -15.848-15.839zm55.748 37.909a8.529 8.529 0 1 0 17.057 0v-44.13a8.529 8.529 0 1 0 -17.057 0zm-218.214 88.013h-206.692a8.531 8.531 0 0 0 -8.5 8.533v34.531a8.531 8.531 0 0 0 8.5 8.533h206.692a8.531 8.531 0 0 0 8.5-8.533v-34.531a8.531 8.531 0 0 0 -8.5-8.533zm-8.553 34.526v-17.46h-189.585v17.46z",
    fill: "url(#GradientFill_1)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon2);
export default __webpack_public_path__ + "static/media/table-icon-2.d31a004448b3c7a8358e36f49b7abffe.svg";
export { ForwardRef as ReactComponent };